import { object, string } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const schema = object({
	password: string()
		.trim()
		.default('')
		.required(validationErrMessages.password),
});
